// Situação da placa de um trator num dia, a partir das licenças dele
// (mesma regra de app.veiculo_licenciado no banco).
export function situacaoDaPlaca(licencasDoVeiculo, dia) {
  const lista = [...licencasDoVeiculo].sort((a, b) => (a.inicio < b.inicio ? 1 : -1));
  const vigente = lista.find((l) => l.inicio <= dia && (l.fim === null || l.fim >= dia));
  if (vigente) {
    return {
      ativa: true,
      desde: vigente.inicio,
      ate: vigente.fim,
      encerraHoje: vigente.fim === dia,
      jaTeve: true,
    };
  }
  return { ativa: false, jaTeve: lista.length > 0, ultimaAte: lista[0]?.fim ?? null };
}

// Agrupa as licenças por veículo: { veiculoId: [licenças] }
export function porVeiculo(licencas) {
  const mapa = {};
  for (const l of licencas) (mapa[l.veiculo_id] ??= []).push(l);
  return mapa;
}
